import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LOGO from "../images/smartlogo2.svg";

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [pendingScroll, setPendingScroll] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  // Get Early Access: scroll to #signup, navigating home first if needed
  const goSignup = () => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      setPendingScroll('signup');
      navigate('/');
    }
  };

  // once home has rendered, do the pending scroll
  useEffect(() => {
    if (pendingScroll && location.pathname === '/') {
      const id = setTimeout(() => {
        document.getElementById(pendingScroll)?.scrollIntoView({ behavior: 'smooth' });
        setPendingScroll(null);
      }, 150);
      return () => clearTimeout(id);
    }
  }, [pendingScroll, location.pathname]);

  // close the dropdown when clicking anywhere outside the navbar
  useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (!e.target.closest('.navbar')) setMenuOpen(false);
    };
    document.addEventListener('click', closeOnOutsideClick);
    return () => document.removeEventListener('click', closeOnOutsideClick);
  }, []);

  const links = [
    { label: 'Platform', path: '/platform' },
    { label: 'Read the whitepaper', path: '/thesis' },
  ];

  return (
    <nav className="navbar sm-navbar">
      <div className="logo" onClick={() => goTo('/')}>
        <img src={LOGO} alt="Smarlytics" />
      </div>

      {/* desktop links */}
      <div className="nav-links">
        {links.map((link) => (
          <a
            key={link.path}
            onClick={() => goTo(link.path)}
            className="nav-link"
          >
            {link.label}
          </a>
        ))}
        <button className="signup-btn" onClick={goSignup}>
          Get Early Access
        </button>
      </div>

      {/* mobile hamburger */}
      <button
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* mobile dropdown */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {links.map((link) => (
          <a
            key={link.path}
            onClick={() => goTo(link.path)}
            className="mobile-link"
          >
            {link.label}
          </a>
        ))}
        <button className="signup-btn" onClick={goSignup}>
          Join Waitlist
        </button>
      </div>
    </nav>
  );
}
